module.exports = __webpack_public_path__ + "static/media/DSC03491.3e33335e.JPG";